"use client";

import { useReportWebVitals } from "next/web-vitals";

export function WebVitalsReporter() {
  useReportWebVitals((metric) => {
    if (process.env.NODE_ENV !== "production") return;
    const body = JSON.stringify({
      name: metric.name,
      value: metric.value,
      rating: metric.rating,
      id: metric.id
    });

    if (navigator.sendBeacon) {
      navigator.sendBeacon("/api/vitals", body);
      return;
    }

    fetch("/api/vitals", {
      method: "POST",
      body,
      keepalive: true,
      headers: { "content-type": "application/json" }
    }).catch(() => undefined);
  });

  return null;
}
